export default function ProductCategoriesSection() {
  const categories = [
    {
      title: "가방",
      description: "업사이클 원단으로 만든 에코백, 크로스백, 백팩 등 다양한 가방 제품",
      image: "https://static.readdy.ai/image/d1a0c06a8edb29d2039b650faf22b9bc/91fa69a825c828313b3ddf5bfc2b723f.png",
      items: ["에코백", "크로스백", "백팩", "파우치"]
    },
    {
      title: "생활 소품",
      description: "업사이클 천으로 직접 바느질해 만든 핸드메이드 캐릭터 인형과 소품들. 각각 조금씩 다른 표정과 형태가 매력포인트",
      image: "https://storage.readdy-site.link/project_files/0c3ec331-9ffb-4d84-a7fc-645a7b3a8243/75a0de9d-0ffe-4c71-9823-fb243f34693f_KakaoTalk_20210215_151806389_1.jpg?v=1a09b581caf0dbafbad1ba3c8bc0542c",
      items: ["캐릭터 인형", "패브릭 인형", "키링 인형", "미니 피규어"]
    },
    {
      title: "의류",
      description: "버려진 원단을 재디자인한 유니크한 업사이클 의류",
      image: "https://public.readdy.ai/ai/img_res/60a44677f219262e05390b290c04c589.jpg",
      items: ["티셔츠", "후드", "자켓", "팬츠"]
    }
  ];

  return (
    <section className="py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-800 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            제품 카테고리
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            re:day는 버려지는 자원을 활용하여
            <br />
            다양한 카테고리의 지속가능한 제품을 만듭니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {categories.map((category, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-bold text-gray-800 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  {category.title}
                </h3>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  {category.description}
                </p>
                
                <div className="flex flex-wrap gap-2 mb-6">
                  {category.items.map((item, idx) => (
                    <span 
                      key={idx}
                      className="px-4 py-2 bg-stone-100 text-gray-700 text-sm rounded-full"
                    >
                      {item}
                    </span>
                  ))}
                </div>

                <button className="w-full px-6 py-3 border-2 border-emerald-600 text-emerald-600 text-sm font-medium rounded-lg hover:bg-emerald-600 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer">
                  제품 보기
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <div className="inline-block bg-white rounded-2xl px-12 py-8 shadow-lg">
            <p className="text-lg text-gray-700 mb-6">
              re:day의 모든 제품은 업사이클 원단과
              <br />
              지속가능한 소재로 제작됩니다
            </p>
            <div className="flex items-center justify-center gap-3">
              <i className="ri-leaf-line text-2xl text-emerald-600"></i>
              <span className="text-base font-medium text-gray-800">100% 지속가능 소재</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}